/* BioRed Light — minimal vanilla JS (Phase A) */
(function () {
  "use strict";

  // Header behaviour: mobile drawer + active nav link ----------------------
  function initHeader() {
    var toggle = document.getElementById("navToggle");
    var links = document.getElementById("navLinks");
    if (toggle && links) {
      toggle.addEventListener("click", function () {
        var open = links.classList.toggle("is-open");
        toggle.setAttribute("aria-expanded", open ? "true" : "false");
      });
      links.addEventListener("click", function (e) {
        if (e.target.tagName === "A") {
          links.classList.remove("is-open");
          toggle.setAttribute("aria-expanded", "false");
        }
      });
    }
    var page = location.pathname.split("/").pop() || "index.html";
    var current = document.querySelector('.nav__links a[data-nav="' + page + '"]');
    if (current) current.setAttribute("aria-current", "page");
  }

  // Subtle fade-up on scroll (respects reduced-motion via CSS) -------------
  function initFades() {
    var faders = document.querySelectorAll(".fade-up");
    if ("IntersectionObserver" in window && faders.length) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add("is-visible");
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
      );
      faders.forEach(function (el) { io.observe(el); });
    } else {
      faders.forEach(function (el) { el.classList.add("is-visible"); });
    }
  }

  // Product gallery: swap main image when a thumbnail is clicked -----------
  function initGallery() {
    var main = document.querySelector(".pdp__main img");
    var thumbs = document.querySelectorAll(".pdp__thumb");
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        var img = t.querySelector("img");
        if (!img) return;
        main.src = img.src;
        main.alt = img.alt;
        thumbs.forEach(function (x) { x.classList.remove("is-active"); });
        t.classList.add("is-active");
      });
    });
  }

  // Rotating hero slider: cross-fade, auto-advance, dots, pause on hover ---
  function initHeroSlider() {
    var slider = document.querySelector(".hero-slider");
    if (!slider) return;
    var slides = [].slice.call(slider.querySelectorAll(".hero-slide"));
    var dots = [].slice.call(slider.querySelectorAll(".hero-dot"));
    if (slides.length < 2) return;
    var i = 0, timer = null;
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var DELAY = 6000;

    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, idx) { s.classList.toggle("is-active", idx === i); });
      dots.forEach(function (d, idx) {
        var on = idx === i;
        d.classList.toggle("is-active", on);
        d.setAttribute("aria-selected", on ? "true" : "false");
      });
    }
    function start() { if (reduce) return; stop(); timer = setInterval(function () { show(i + 1); }, DELAY); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    dots.forEach(function (d, idx) {
      d.addEventListener("click", function () { show(idx); start(); });
    });
    slider.addEventListener("mouseenter", stop);
    slider.addEventListener("mouseleave", start);
    show(0);
    start();
  }

  // Shop-type toggle: switch between individual products and bundles -------
  function initShopTabs() {
    var tabs = [].slice.call(document.querySelectorAll("[data-shop-tab]"));
    if (!tabs.length) return;
    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        var id = tab.getAttribute("data-shop-tab");
        tabs.forEach(function (t) { t.setAttribute("aria-selected", t === tab ? "true" : "false"); });
        document.querySelectorAll(".shop-panel").forEach(function (p) {
          p.classList.toggle("is-active", p.id === id);
        });
      });
    });
  }

  // Our Story timeline: fill the centre line + light up nodes as you scroll ---
  function initTimeline() {
    var tl = document.querySelector(".timeline");
    if (!tl) return;
    var fill = tl.querySelector(".timeline__fill");
    var items = [].slice.call(tl.querySelectorAll(".timeline__item"));
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if ("IntersectionObserver" in window && !reduce) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { e.target.classList.add("is-visible", "is-active"); }
          });
        },
        { threshold: 0.35, rootMargin: "0px 0px -10% 0px" }
      );
      items.forEach(function (it) { io.observe(it); });
    } else {
      items.forEach(function (it) { it.classList.add("is-visible", "is-active"); });
    }

    if (fill && !reduce) {
      var ticking = false;
      function update() {
        ticking = false;
        var rect = tl.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var progress = (vh * 0.55 - rect.top) / rect.height;
        progress = Math.max(0, Math.min(1, progress));
        fill.style.height = (progress * 100).toFixed(2) + "%";
      }
      function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", onScroll, { passive: true });
      update();
    } else if (fill) {
      fill.style.height = "100%";
    }
  }

  // Count-up numbers (data-count) when scrolled into view --------------------
  function initCountUp() {
    var els = [].slice.call(document.querySelectorAll("[data-count]"));
    if (!els.length) return;
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    function fmt(el, n) {
      return (el.getAttribute("data-prefix") || "") + n + (el.getAttribute("data-suffix") || "");
    }
    function run(el) {
      var target = parseFloat(el.getAttribute("data-count")) || 0;
      if (reduce) { el.textContent = fmt(el, target); return; }
      var dur = 1300, startTime = null;
      function step(ts) {
        if (startTime === null) startTime = ts;
        var p = Math.min(1, (ts - startTime) / dur);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = fmt(el, Math.round(target * eased));
        if (p < 1) requestAnimationFrame(step);
        else el.textContent = fmt(el, target);
      }
      requestAnimationFrame(step);
    }
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { run(e.target); io.unobserve(e.target); }
          });
        },
        { threshold: 0.6 }
      );
      els.forEach(function (el) { io.observe(el); });
    } else {
      els.forEach(function (el) { run(el); });
    }
  }

  function init() {
    initHeader();
    initFades();
    initGallery();
    initHeroSlider();
    initShopTabs();
    initTimeline();
    initCountUp();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
